export function appendAdditionalParameters(url, additionalParameters) {
  if (!additionalParameters || !url) {
    return url
  }

  try {
    const urlObj = new URL(url)
    const additionalParams = new URLSearchParams(additionalParameters)

    additionalParams.forEach((value, key) => {
      urlObj.searchParams.append(key, value)
    })

    return urlObj.toString()
  } catch (error) {
    console.warn(`Failed to append additional parameters for url: ${url}`)
    console.warn(error)
    return url
  }
}
